exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-07094600] .el-link.el-link--success {\n  color: #22c655;\n}", ""]);

// exports
